import { OFrame } from "../components/OFrame"

export const Preview = () => {
    return (
        <div className="w-full h-full flex-grow-1 flex items-center justify-center bg-stone-800 overflow-y-auto relative">
            <OFrame/>
        </div>
    )
}